import styled from '@mui/material/styles/styled'
import IconButton from '@mui/material/IconButton'

export const PrimaryIconButton = styled(IconButton)(({ theme }) => `
    background-color: ${theme.palette.primary.light};
    textTransform: 'capitalize';
    fontFamily: 'Roboto-Medium';
    :hover{
        background-color: ${theme.palette.primary.dark}
    }
`)

export const SecondaryIconButton = styled(IconButton)(({ theme }) => `
    background-color: ${theme.palette.secondary.light};
    textTransform: 'capitalize';
    fontFamily: 'Roboto-Medium';
    :hover{
        background-color: ${theme.palette.secondary.main}
    }
`)